import { createSvgIcon } from '@mui/material'

export const PowerRightIcon = createSvgIcon(
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5 11.5L5 12.5L6.85 12.5L10.35 16L15 16L15 8L10.35 8L6.85 11.5L5 11.5ZM3 9.5L6 9.5L9.5 6L15 6C15.55 6 16.0208 6.19583 16.4125 6.5875C16.8042 6.97917 17 7.45 17 8L17 9L16 8L21 8L21 10L17 10L17 14L21 14L21 16L16 16L17 15L17 16C17 16.55 16.8042 17.0208 16.4125 17.4125C16.0208 17.8042 15.55 18 15 18L9.5 18L6 14.5L3 14.5L3 9.5Z'
      fill='currentColor'
    />
  </svg>,
  'PowerRightIcon',
)
